export default class ArgCallerType
{
	static FormModule = "FormModule";
	static StringEditor = "StringEditor";
	static MainMenu = "MainMenu";
	static MainForm = "MainForm";
}


// WEBPACK FOOTER //
// ./src/forms/sys/ArgCallerType.js